<template>
    <div class="visual-information">
        <div class="visual-image">
            <ArboIcon :name="props.visualName" class="visual arbo-ui-styles" type="visual" />
        </div>

        <div class="visual-label">
            {{ props.label }}
        </div>
    </div>
</template>
<script setup lang="ts">
type Props = {
    visualName: string;
    label: string;
};
const props = defineProps<Props>();
</script>
